import { PanelLeft, PanelLeftClose, X } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface SidebarToggleProps {
  isMobile: boolean;
  isCollapsed: boolean;
  onToggle: () => void;
}

export const SidebarToggle = ({ isMobile, isCollapsed, onToggle }: SidebarToggleProps) => {
  const Icon = isMobile ? X : isCollapsed ? PanelLeft : PanelLeftClose;

  return (
    <div
      className={cn(
        "border-t border-sidebar-border bg-sidebar/50 backdrop-blur-sm transition-all",
        isCollapsed ? "p-2" : "p-4",
      )}
    >
      <Button
        variant="ghost"
        onClick={onToggle}
        className={cn(
          "flex h-10 w-full items-center gap-3 rounded-lg transition-all duration-200",
          "text-sidebar-foreground/60 hover:bg-sidebar-accent hover:text-sidebar-foreground",
          isCollapsed ? "justify-center px-0" : "justify-start px-3",
        )}
      >
        <Icon size={18} />
        {!isCollapsed && !isMobile && <span className="text-sm font-medium">Recolher Menu</span>}
      </Button>
    </div>
  );
};
